module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/bg-unsuccess.cacc1ba6.png";